var map = {
	"./navigation.de-CH.json": 1116,
	"./navigation.de-DE.json": 1117,
	"./navigation.en-CA.json": 1118,
	"./navigation.en-GB.json": 1119,
	"./navigation.en-IN.json": 1120,
	"./navigation.en-ME.json": 1121,
	"./navigation.en-US.json": 1122,
	"./navigation.es-EM.json": 1123,
	"./navigation.es-ES.json": 1124,
	"./navigation.fr-BE.json": 1125,
	"./navigation.fr-CA.json": 1126,
	"./navigation.fr-CH.json": 1127,
	"./navigation.nl-BE.json": 1128,
	"./navigation.nl-NL.json": 1129,
	"./navigation.pl-PL.json": 1130,
	"./navigation.pt-BR.json": 1131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1115;